import React from 'react';
import { listPromos, createPromo } from '../../services/promoApi';

const Coupons = () => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [form, setForm] = React.useState({
    code: '',
    name: '',
    discount: 10,
    status: 'ACTIVE',
  });
  const [error, setError] = React.useState('');

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await listPromos(
        new URLSearchParams({ page: '1', limit: '50' })
      );
      setRows(data || []);
    } catch (e) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    load();
  }, []);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const create = async (e) => {
    e.preventDefault();
    try {
      await createPromo({
        code: form.code.trim().toUpperCase(),
        name: form.name.trim() || form.code.trim().toUpperCase(),
        type: 'percentage',
        value: Number(form.discount),
        status: form.status || 'ACTIVE',
      });
      setForm({ code: '', name: '', discount: 10, status: 'ACTIVE' });
      await load();
    } catch (e) {
      const msg = e?.message || 'Failed to create';
      setError(msg);
    }
  };

  return (
    <div className="max-w-[1140px] w-full mx-auto px-4 sm:px-6 lg:px-0">
      <div
        className="bg-white rounded-[12px] p-4 sm:p-6"
        style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
      >
        <h2 className="text-[#000] text-[20px] font-semibold mb-4">Coupons</h2>

        <form onSubmit={create} className="flex flex-wrap items-end gap-3 mb-6">
          <div>
            <label className="block text-xs mb-1">Code</label>
            <input
              required
              name="code"
              value={form.code}
              onChange={onChange}
              className="border rounded px-3 py-2"
              placeholder="e.g. SAVE20"
            />
          </div>
          <div>
            <label className="block text-xs mb-1">Name</label>
            <input
              required
              name="name"
              value={form.name}
              onChange={onChange}
              className="border rounded px-3 py-2"
              placeholder="e.g. Summer Sale 20%"
            />
          </div>
          <div>
            <label className="block text-xs mb-1">Discount %</label>
            <input
              required
              min="1"
              max="100"
              name="discount"
              value={form.discount}
              onChange={onChange}
              type="number"
              className="border rounded px-3 py-2 w-28"
            />
          </div>

          <div>
            <label className="block text-xs mb-1">Status</label>
            <select
              name="status"
              value={form.status}
              onChange={onChange}
              className="border rounded px-3 py-2"
            >
              <option value="ACTIVE">ACTIVE</option>
              <option value="INACTIVE">INACTIVE</option>
            </select>
          </div>
          <button className="bg-black text-white px-4 py-2 rounded">
            Create
          </button>
        </form>

        {error && <p className="text-red-600 mb-3">{error}</p>}

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead>
                <tr className="bg-[#F3F4F6]">
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Code
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Type
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Value
                  </th>
                  <th className="px-4 py-3 text-left text-xs uppercase">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {(rows || []).map((p) => (
                  <tr key={p._id} className="border-b">
                    <td className="px-4 py-3 font-mono">{p.code}</td>
                    <td className="px-4 py-3">{p.type}</td>
                    <td className="px-4 py-3">{p.value}%</td>
                    <td className="px-4 py-3">{p.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Coupons;
